import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';

import { FeedbackComponent } from './component/feedback.component';
import { FeedbackService } from './service/feedback.service';

export const /** @type {?} */ SlackUrlToken = new InjectionToken<string>('SlackUrlToken');
export class NgxSlackModule {
/**
 * Initialize NgxSlack
 * 
 * @param {?} slackUrl Slack Webhook URL or any URL that accept POST and object { text: '...' }
 * @return {?}
 */
static initializeApp(slackUrl: string) {
    return {
      ngModule: NgxSlackModule,
      providers: [
        { provide: SlackUrlToken, useValue: slackUrl }
      ]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule,
    HttpModule
  ],
  declarations: [
    FeedbackComponent
  ],
  providers: [
    FeedbackService
  ],
  exports: [FeedbackComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgxSlackModule_tsickle_Closure_declarations() {
/** @type {?} */
NgxSlackModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxSlackModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
